export default __webpack_public_path__ + "static/media/pnsv_stand_Zonte.c6448adc.png";